import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import firebase from 'firebase';
import isReachable from 'is-reachable';

Vue.config.productionTip = false;

const config = {
  apiKey: 'AIzaSyCI24_za8RDkIdQNk8urFfwB5K19fmnknM',
  authDomain: 'canon-costs.firebaseapp.com',
  databaseURL: 'https://canon-costs.firebaseio.com',
  projectId: 'canon-costs',
  storageBucket: 'canon-costs.appspot.com',
  messagingSenderId: '167272551322',
  appId: '1:167272551322:web:8d06cdafa88a1640'
};

const moment = require('moment');
require('moment/locale/da');

Vue.use(require('vue-moment'), {
  moment
});
Vue.use(isReachable);

console.log('LOCALE LOCALE LOCALE', Vue.moment().locale()); //es

firebase.initializeApp(config);
export const db = firebase.firestore();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
